import api from './HttpUtil';

export interface iObra {
    id: number;
    autor_id: number;
    fotografo_id: number;
    usuario_creacion: number;
    usuario_modificacion: number;
    titular: string;
    descriptores_tematicos: Array<String>;
    descriptores_topograficos: Array<String>;
    descriptores_onomastico: Array<String>;
    descriptores_ocultos: Array<String>;
    fecha_epoca: string;
    materiales_tecnicas: string;
    altura: string;
    ancho: string;
    profundidad: string;
    diametro: string;
    funcion_genero: string;
    descripcion_obra: string;
    inscripciones: string;
    periodo: string;
    observaciones_contenido: string;
    creditos_fotografia: string;
    codigo_origen: number;
    indice_codigo_origen: number;
    comitente: string;
    fecha_toma_imagen: string;
    fecha_creacion_imagen: string;
    proceso_fotografico: string;
    soporte_secundario: string;
    ubicacion: string;
    fondo_coleccion: string;
    derechos_autor_pieza: 0;
    derechos_autor_imagen: 0;
    derechos_propietario_pieza: 0;
    estado_conservacion: string;
    historia_archivistica: string;
    documentacion_asociada: string;
    original: number;
    nivel_descripcion: string;
    notas_forma: string;
    catalogador_id: number;
    publicar: number;
    editor: string;
    coleccionista: string;
    codigo_antiguo: string;
    imagen: string;
    autor_nombre?: string,
    autor_apellido?: string,
    fotografo_nombre?: string,
    fotografo_apellido?: string,
    ejes?: Array<{obra_id: number,eje_tematico_id: number}>
}

export interface iFuncion {
    codigo: string,
    nombre: string
}

export interface iPeriodo {
    abreviatura: string,
    nombre: string,
    codigo: number,
    lastCode: number
}

export interface iFormSearch {
    funcion_genero?: string;
    periodo?: string;
    autor_id?: number;
    titular?: string;
}

export default {
    getByTematico(tematico: number){
        return api.get('/obra/tematico/'+ tematico);
    },
    getById(id: string){
        return api.get('/obra/'+id);
    },

    getByPeriodoMedio(periodo: string, medio: string, page:number=0,cant:number=5){
        return api.get(`/obra/periodo/${periodo}/medio/${medio}`,{params:{page, cant}});
    },
    getFunciones(){
        return api.get('/funcion/all');
    },
    getPeriodos(){
        return api.get('/periodo/');
    },
    postSearch(body:iFormSearch, page:number=0,cant:number=5){
        return api.post('/obra/search',body,{params:{page, cant}});
    }
}